import React, { useState } from "react";
import logo from "../../assets/images/duke-logo.png";
import dayjs from "dayjs";
const MatchupsItem = ({
  teamLogo,
  opponentLogo,
  time,
  away,
  date,
  home,
  key,
  projected_away_score = null,
  projected_home_score = null,
  isTrader = false,
}) => {
  // const dateTime = date + " " + time;
  // const convertDate = dayjs(new Date(dateTime.replace(/-/g, "/"))).format("llll");
  return (
    <div className="item-slider-list" key={away + home}>
      <div className="Matchup-item-slider">
        <div className="team-logos-container">
          <div className="team-logo">
            <img src={`http://shotqualitybets.com/static/media/logos/${home}.png`} />
          </div>
          <span>VS</span>
          <div className="team-logo">
            <img src={`http://shotqualitybets.com/static/media/logos/${away}.png`} />
          </div>
        </div>
        {/* <p className="time">{convertDate + ", ET"}</p> */}
        <p className="time">{time?.replace(":00 ", " ") + " ET"}</p>
        <p className="teams d-flex justify-content-between">
          <span>{home}</span> {!isTrader && projected_home_score && <span>{projected_home_score}</span>}
        </p>
        <p className="teams d-flex justify-content-between">
          <span>{away}</span> {!isTrader && projected_away_score && <span>{projected_away_score}</span>}
        </p>
      </div>
    </div>
  );
};

export default MatchupsItem;
